import { isM } from "./alpha"

// ---------------------------------------------------------------------------

const w = window.innerWidth
const h = window.innerHeight

export let values = {
    camera: {
        fov: isM ? 75 : 55,

        // Splash
        pos: {x: -16, y: 7.5, z: -8.5},
        target: {x: 0, y: 2, z: -5}
    }
}

if(isM) {
    // values.camera.pos.z = 40
}